/**
 * @description
 *	A deconstructed and decoded URI for easy handling.
 */
export default class URI {
	public readonly fragment: string
	public readonly hostname: string
	public readonly original: URL
	public readonly password: string
	public readonly path: string
	public readonly port: number
	public readonly query: string
	public readonly queryParameters: Map<string, string>
	public readonly schema: string
	public readonly username: string

	private constructor(url: URL) {
		this.fragment = decodeURIComponent(url.hash.substring(1))
		this.hostname = decodeURIComponent(url.hostname)
		this.original = new URL(url)
		this.password = decodeURIComponent(url.password)
		this.path = decodeURIComponent(url.pathname)
		this.port = +url.port
		this.query = decodeURIComponent(url.search.substring(1))
		this.queryParameters = new Map<string, string>(url.searchParams.entries())
		this.schema = url.protocol.substring(0, url.protocol.length - 1)
		this.username = decodeURIComponent(url.username)
	}

	public get origin(): string {
		return `${this.schema}://${this.hostname}:${this.port}`
	}

	public static fromURL(url: URL): URI {
		return new URI(url)
	}

	public toString(): string {
		return new URL(
			`${this.schema}://${this.username}:${this.password}@${this.hostname}:${this.port}${this.path}?${this.query}#${this.fragment}`
		).href
	}
}
